import * as ACTION_TYPES from "./action-types"

/**
* setting superAdminWidgetData state
* @param {Object} data
*/
export const setSuperAdminWidgetData = (data) => {
  return {
    type: ACTION_TYPES.GET_SUPERADMIN_WIDGET_DATA,
    payload: data,
  }
}

/**
* setting superAdminTableData state
* @param {Array} data
*/
export const setSuperAdminTableData = (data) => {
  return {
    type: ACTION_TYPES.SET_SUPERADMIN_TABLE_DATA,
    payload: data
  }
}

/**
* setting superAdminAllTableData state
* @param {Array} data
*/
export const setAllSuperAdminTableData = (data) => {
  return {
    type: ACTION_TYPES.SET_ALL_SUPERADMIN_TABLE_DATA,
    payload: data
  }
}

export const setActiveOrgCount = (count) => {
  return {
    type: ACTION_TYPES.SET_ACTIVE_ORG_COUNT,
    payload: count
  }
}

export const setInActiveOrgCount = (count) => {
  return {
    type: ACTION_TYPES.SET_INACTIVE_ORG_COUNT,
    payload: count
  }
}

export const setAliasName = (aliasName) => {
  return {
    type: ACTION_TYPES.SET_SUPERADMIN_STREAM_ALIASNAME,
    payload: aliasName
  }
}